import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from 'src/app/_services/toaster.service';
import { ClientsService} from 'src/app/_services/generatedServices';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ClientDayEventType, ClientProgramWorkoutDayViewModel } from 'src/app/_models/generatedModels';
import { dateAsUTCNoTime } from 'src/app/_helpers/extensions.module';

@Component({
  selector: 'workout-add-to-calendar-dialog',
  templateUrl: 'workout-add-to-calendar.component.html',
})
export class WorkoutAddToCalendarComponent implements OnInit {
  initialized = false;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;

  @Input()
    clientUserId: number;

  @Input()
    workoutId: number;

  @Input()
    workoutName: string;

  @Output()
  saved = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private toastr: ToasterService, private clientService: ClientsService, private auth: AuthenticationService, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm() {
    this.formGroup = this.fb.group({
      clientUserId: [this.clientUserId, Validators.required],
      workoutId: [this.workoutId],
      assignedByUserId: [this.auth.user.id],
      workoutDate: [null, Validators.required]
    });

    this.initialized = true;
  }

  onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      return;
    }

    this.submitComplete = new Promise((resetButton:any, reject) => {
      const formData: ClientProgramWorkoutDayViewModel = Object.assign({}, this.formGroup.getRawValue());
      formData.sortOrder = 1;
      formData.organizationId = this.auth.organizationId;
      formData.eventType = ClientDayEventType.Workout;
      formData.workoutDate = dateAsUTCNoTime(formData.workoutDate);

      this.clientService.addClientProgramWorkoutDay(this.clientUserId, formData).subscribe((result) => {
        this.toastr.success('Workout Added', 'Success');
        this.saved.emit(true);
        this.activeModal.dismiss('saved');
      });
    });
  }
}
